import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import "./VideoPlayer.css"
import $ from 'jquery'
const VideoPlayer = (props: any) => {


    const [blockEnter, setBlockEnter] = useState<any>("hideInfo");



    useEffect(() => {
        $(document).ready(function () {
            $('.hideInfo').bind('touchstart touchend', function (e) {
                e.preventDefault();
                $(this).toggleClass('hideInfo');
            });
        });

    }, [])
    return (

        // Lazy load the YouTube player
        <>
            <div className="video-container"></div>
            <div className='videowrapper'
            // https://iframe.mediadelivery.net/play/150141/08a0e91a-b0cc-499b-b62b-7774bdeb985f
            // 08a0e91a-b0cc-499b-b62b-7774bdeb985f

            >


                {props.video_path && props.video_path.includes('vimeo') == false ? (
                    <ReactPlayer id="resdad"


                        style={{ width: '100% !important' }}

                        url={`'https://www.youtube.com/watch?v=${props.video_path}?autoplay=1&rel=0&showinfo=0'`} playing={false} controls={true}

                        config={{
                            youtube: {
                                playerVars: { showinfo: 0, modestbranding: 1, autoplay: 1, disablekb: 1 }
                            },

                        }}

                    />

                ) : (
<iframe src={`${props.video_path}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`} width="1280" height="720"  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" title="Introduction"></iframe>
                   

                )

                }





            </div>
        </>
    )
}


export default VideoPlayer